import { Fab, styled } from "@mui/material";

export const ActiveFab = styled(Fab)`
  &.active {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.common.white};
  }
`;
